"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _theme = require("@vds/theme");
var _checkboxes = require("@vds-core/checkboxes");
var LETTER_SPACING = (0, _javascriptStyleHelpers.calculateRem)(0.5);
var ERROR_LEFT_MARGIN = (0, _javascriptStyleHelpers.calculateRem)(-2);
var BORDER_RADIUS = "0rem";
var propTypes = {
  /**
   * Component will render in Inverted state.
   */
  inverted: _propTypes["default"].bool
};
var defaultProps = {
  inverted: false
};
var Checkbox = function Checkbox(props) {
  var inverted = props.inverted;
  var _calculateBorderWidth = function _calculateBorderWidth(_ref) {
    var error = _ref.error,
      disabled = _ref.disabled;
    return error && !disabled ? (0, _javascriptStyleHelpers.calculateRem)(2) : (0, _javascriptStyleHelpers.calculateRem)(1);
  };
  var _calculateBoxShadow = function _calculateBoxShadow(_ref2) {
    var hovered = _ref2.hovered,
      error = _ref2.error,
      disabled = _ref2.disabled,
      surface = _ref2.surface;
    return hovered && !error && !disabled ? "0 0 0 ".concat((0, _javascriptStyleHelpers.calculateRem)(1), " ").concat(surface === "dark" ? _theme.colors.white : _theme.colors.black) : error && !disabled ? "0 0 0 ".concat((0, _javascriptStyleHelpers.calculateRem)(1), " ").concat(_theme.colors.orange) : "none";
  };
  var _calculateCheckboxBackgroundColor = function _calculateCheckboxBackgroundColor(_ref3) {
    var disabled = _ref3.disabled,
      selected = _ref3.selected,
      surface = _ref3.surface;
    if (disabled && selected) {
      return surface === "dark" ? _theme.colors.coolGray10 : _theme.colors.coolGray3;
    }
    if (selected) {
      return surface === "dark" ? _theme.colors.white : _theme.colors.black;
    }
    return "transparent";
  };
  var _calculateBorderColor = function _calculateBorderColor(_ref4) {
    var disabled = _ref4.disabled,
      error = _ref4.error,
      surface = _ref4.surface;
    if (disabled) {
      return surface === "dark" ? _theme.colors.coolGray10 : _theme.colors.coolGray3;
    }
    if (error) {
      return _theme.colors.orange;
    }
    return surface === "dark" ? _theme.colors.white : _theme.colors.black;
  };
  return /*#__PURE__*/_react["default"].createElement(_checkboxes.Checkbox, (0, _extends2["default"])({}, props, {
    surface: inverted ? "dark" : "light",
    letterSpacing: LETTER_SPACING,
    borderRadius: BORDER_RADIUS,
    focusBorderRadius: BORDER_RADIUS,
    errorMarginLeft: ERROR_LEFT_MARGIN,
    calculateBorderWidth: _calculateBorderWidth,
    calculateBoxShadow: _calculateBoxShadow,
    calculateBorderColor: _calculateBorderColor,
    calculateCheckboxBackgroundColor: _calculateCheckboxBackgroundColor
    // selectedHoverBorderWidth={SELECTED_HOVER_BORDER_WIDTH}
  }));
};

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
var _default = exports["default"] = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/checkboxes/dist/cjs/components/Checkbox.js
// module id = 565
// module chunks = 0